exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-email-preview-modal_row{display:block;margin-top:10px}.c-email-preview-modal_label{font-weight:bold;display:inline-block;margin-right:10px}.c-email-preview-modal_message-label{font-weight:bold;display:block}.c-email-preview-modal_content{margin-top:5px;margin-bottom:30px}", ""]);

// exports
